import { Component, Input, OnInit } from "@angular/core";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { ServiceItemService } from "src/app/services/service-item.service";
import { ServiceItem } from "../../model/model";

@Component({
  selector: "app-services-view",
  templateUrl: "./services.component.html"
})
export class ServicesComponent implements OnInit {

  constructor(private serviceItemService: ServiceItemService, protected $gaService: GoogleAnalyticsService) { }

  @Input()
  serviceItems: ServiceItem[] = [];

  @Input()
  query: string;

  onFilterTextChange(){
    console.log(this.query);
  }

  ngOnInit(): void {
    this.serviceItems = this.serviceItemService.getAll();
    this.$gaService.pageView("/service", "Visit the catalog");
  }
}
